import React, { useState, useEffect } from 'react';
import { literatureService } from '../services/literatureService.ts';
import { useFilters } from '../context/FilterContext.tsx';

export function LiteratureSummarize() {
    const { lit_filter } = useFilters();
    const [total, setTotal] = useState(0);

    const [totalWords, setTotalFullTextWords] = useState(0);
    const [fullTexts, setTotalFullTexts] = useState('');

    const [llmProvider, setLlmProvider] = useState('');
    const [prompt, setPrompt] = useState('');
    const [llmResponse, setLlmResponse] = useState('');

    const fetchLiterature = async (currentPage: number) => {
        try {
            const data = await literatureService.getLiterature({
                page: currentPage,
                perPage: 200,
                lit_filter: {
                    ...lit_filter,
                    page: currentPage,
                },
            });
            setTotal(data.total);
            setTotalFullTextWords(data.total_full_text_words);
        } catch (error) {
            console.error('Error fetching literature:', error);
        }
    };
    const fetchFullText = async () => {
        try {
            const data = await literatureService.getFullTexts(lit_filter);
            setTotalFullTexts(data);
        } catch (error) {
            console.error('Error fetching literature full texts:', error);
        }
    };

    const summarize = async () => {
        try {
            const response = await literatureService.summarizeLiterature(prompt, fullTexts, llmProvider);
            setLlmResponse(response.summary);
        } catch (error) {
            console.error('Error summarizing literature:', error);
        }
    };

    useEffect(() => {
        fetchLiterature(1);
    }, [lit_filter]);

    return (
        <div className="literature-list">
            <h2>Summarize {total} paper</h2>
            <button onClick={fetchFullText} className="reload-button">
                🔄 Get all full texts ({total} paper / {totalWords} words)
            </button>
            <select
                value={llmProvider}
                onChange={(e) => setLlmProvider(e.target.value)}
                className="provider-select">
                <option>Please select provider</option>
                {/* <option value="claude-3-5-sonnet-20241022">Claude 3 Sonnet</option>
                <option value="deepseek-r1:14b">Deepseek 14B</option>
                <option value="deepseek-r1:1.5b">Deepseek 1.5B</option> */}
                <option value="gemini-2.0-flash">Gemini 2.0 Flash</option>
            </select>
            <h3>Prompt</h3>
            <textarea
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                rows={4}
                className="prompt-textarea"
            />
            <h3>Paper Content</h3>
            <textarea>{fullTexts}</textarea>

            <button
                onClick={summarize}
                className="summarize-button"
                disabled={!llmProvider || !prompt || !fullTexts}>
                Summarize
            </button>
            <pre className="llm-response">{llmResponse}</pre>
        </div>
    );
}
